import React, { useState, useRef } from 'react';
import { Turl } from './tUrl.js'
import './css/Deposit.css'; // Создайте этот CSS файл
import { t } from 'ttag';
import { mixpanel } from './mp.js';

const tg = window.Telegram ? window.Telegram.WebApp : null;

function Deposit({ wallet, depWallet, isDoDep, setisDoDep, setErrorMessage, handlesetIndex, setIsAuthorized }) {
    const text = wallet
    const [isCopied, setIsCopied] = useState(false);

    const copyToClipboard = async () => {
        mixpanel.track('buyingEquity-copyToClipboard')
        try {
            await navigator.clipboard.writeText(wallet);
            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 2000); // Сброс состояния через 2 секунды
        } catch (err) {
            console.error('Failed to copy text: ', err);
            // Можно добавить обработку ошибки (например, показать сообщение пользователю)
        }
    };

    const doDep1 = () => {
        mixpanel.track('buyingEquity-alredyPaid')
        setisDoDep(true);
        doDep();
    }

    const doDep = async () => {
        try {
            const _userData = tg ? tg.initData : null;
            let userData = { initData: _userData }
            if (userData) {
                const response = await fetch(Turl + '/api/doDep', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(userData)
                });


                if (!response.ok) { // Check if the response status indicates an error
                    setisDoDep(false);
                    setErrorMessage(response.message || `HTTP error! Status: ${response.status}`);
                }
                const rData = await response.json(); // Пытаемся разобрать детали ошибки из ответа


                if (rData.status == 9) {
                    setisDoDep(false);
                    setErrorMessage(`Not enough usdt in the account: ${rData.volume}, try leter.`);
                }
                if (rData.status == 1) {
                    setisDoDep(false);
                    setErrorMessage(`${rData.volume} USDT processed successfully`);
                    handlesetIndex(0);
                    setIsAuthorized(false);

                }

                setisDoDep(false);

            } else {
                setisDoDep(false);
                // Handle case where user data is not available (e.g., show error)
                console.warn("Telegram user data not available.");
                // You might want to display an error message to the user here.

            }

        } catch (error) {
            setisDoDep(false);
            console.error('Authentication error:', error);
            setErrorMessage(error.message || 'An unexpected error occurred.');

        }
    };


    return (

        <div style={{ width: "100%" }}>
            <div className="copyable-text-container">
                <div className="text-display">
                    {text}
                </div>
                <button className="copy-button" onClick={copyToClipboard}>
                    {isCopied ? t`Copied!` : t`Copy`}
                </button>
            </div>

            <div className="deposit-blok">
                <div className="deposit-blok-sub">
                    {t`Send the amount of USDT (minimum 10 USDT) you plan to use to purchase BitBook tokens to this BEP-20 address. After completing the transaction, confirm it by clicking the «ALREADY PAID» button.`}
                </div>
            </div>

            <div className="paid" >
                <button className="paid-button" onClick={doDep1} disabled={isDoDep}>
                    {isDoDep ? (
                        <div className="loader"></div>
                    ) : (
                        t`ALREADY PAID`
                    )}
                </button>
            </div>

            {depWallet ?
                <div className="deposit-blok">
                    <div className="deposit-blok-sub">
                        {t`Your wallet address is linked in the system for all future payouts:`}
                    </div>
                    <div className="deposit-blok-sub sub-bold">
                        {depWallet}
                    </div>
                </div>
                : <div className="deposit-blok">
                    <div className="deposit-blok-sub sub-red">
                        <p>{t`The wallet address used for the FIRST transaction is permanently linked to the smart contract for all future payouts and CANNOT be changed.`}</p>
                        <p>{t`All payouts (such as referral bonuses, dividends), as well as BitBook equity tokens, will be tied to the wallet from which the first purchase was made.`}</p>
                    </div>
                </div>}
            <div className="deposit-blok">
                <div className="deposit-blok-sub">
                    <p>{t`Recommendations:`}</p>
                    <p>{t`1. Use a non-exchange hot or cold wallet.
                        For example: TrustWallet, SafePal, MetaMask, Safe3, etc.`}</p>
                    <p>{t`2. Store the SEED phrase of the wallet on a physical medium to be able to recover it in case your device is lost.`}</p>
                    <p>{t`3. If the SEED phrase is lost, the wallet cannot be recovered. This will result in a complete loss of access to the platform and any received funds.`}</p>
                    <p>{t`4. Be extremely careful when creating your wallet!`}</p>

                </div>
            </div>
            <div className="deposit-blok">
                <div className="deposit-blok-sub sub-red">
                    <p>{t`After sending the funds, you must click the «ALREADY PAID» button for the system to start processing your transaction.`}</p>
                    <p>{t`If you don’t do this, the system will remain in standby mode until confirmation is received by pressing the «ALREADY PAID» button.`}</p>
                </div></div>

        </div >
    );
}

export { Deposit };